import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function KeywordSearchVolume() {
  const [keyword, setKeyword] = useState("");
  const [result, setResult] = useState(null);

  const handleCheck = () => {
    if (!keyword.trim()) return;

    // Dummy/mock data (can be replaced with API later)
    const fakeData = {
      keyword: keyword,
      volume: Math.floor(Math.random() * 100000),
      cpc: (Math.random() * 5).toFixed(2),
      competition: (Math.random()).toFixed(2),
    };

    setResult(fakeData);
  };

  return (
    <>
      <Helmet>
        <title>Free Keyword Search Volume Checker Tool - SEO Insights for Your Keywords</title>
        <meta
          name="description"
          content="Check keyword search volume, CPC, competition, and SEO insights for any keyword instantly. Free and no signup required. Get accurate data to improve your SEO strategy."
        />
        <meta name="keywords" content="keyword search volume, keyword volume checker, SEO keyword tool, keyword CPC, keyword competition checker, free keyword tool" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://freelity.com/keyword-search-volume"
        />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Keyword Search Volume Checker</h2>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Enter a keyword"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />

          <button className="btn btn-primary mb-4" onClick={handleCheck}>
            Check Volume
          </button>

          {result && (
            <div className="card p-4">
              <h4 className="mb-3">Results for: <strong>{result.keyword}</strong></h4>
              <p><strong>Search Volume:</strong> {result.volume.toLocaleString()}</p>
              <p><strong>CPC:</strong> ${result.cpc}</p>
              <p><strong>Competition:</strong> {result.competition}</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}


